import React, { useState } from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App.js'
import { SearchProvider } from './context/SearchContext.js'

function Footer () {
  const email = 'lolmasterypoints@gmail.com'

  const [message, setMessage] = useState('')

  const copyEmailToClipboard = async (e) => {
    e.preventDefault()
    try {
      await navigator.clipboard.writeText(email)
      setMessage('Email address copied to clipboard! 🎉')
      setTimeout(() => setMessage(''), 2000)
    } catch (err) {
      setMessage('Failed to copy email. 😢')
      setTimeout(() => setMessage(''), 2000)
    }
  }

  return (
    <footer>
      <div className="footer-content">
        <p>Having issues? Email us at <a href="#" onClick={copyEmailToClipboard}>{email}</a></p>
        {message && <div className="notification">{message}</div>}
      </div>
    </footer>
  )
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <SearchProvider>
      <App />
      <Footer />
    </SearchProvider>
  </React.StrictMode>
)
